/*
 * @Author: alex
 * @Date: 2022-12-05 10:53:31
 * @LastEditors: alex
 * @LastEditTime: 2022-12-05 13:25:34
 * @Description: 处理地图投影
 * Copyright (c) 2022 by piesat, All Rights Reserved.
 */
import { register } from 'ol/proj/proj4'
import proj4 from 'proj4'
import { addProjection, Projection } from 'ol/proj'

export const EPSG4490 = 'EPSG:4490'

export const EPSG4326 = 'EPSG:4326'
export const EPSG3857 = 'EPSG:3857'

export type CrsDetail = {
  // 描述
  projection: string
  olProjection: Projection
}

const definedCrs: Map<string, CrsDetail> = new Map()

/**
 * 注册 4490
 */
registerCrs(EPSG4490, {
  projection: '+proj=longlat +ellps=GRS80 +no_defs +type=crs',
  olProjection: new Projection({
    code: EPSG4490,
    extent: [-180, -90, 180, 90],
    worldExtent: [-180, -90, 180, 90],
    units: 'degrees' //Projection units: `'degrees'`, `'ft'`, `'m'`, `'pixels'`, `'tile-pixels'` or `'us-ft'.
  })
})
/**
 * 注册空间参考
 * @param crsCode crs code eg: 'EPSG:4326'
 * @param crsDetail 详细
 * @returns 注册表
 */
export function registerCrs(
  crsCode: string,
  crsDetail: CrsDetail
): Map<string, any> {
  if (!definedCrs.has(crsCode)) {
    proj4.defs(crsCode, crsDetail.projection)
    register(proj4)
    addProjection(crsDetail.olProjection)
    definedCrs.set(crsCode, crsDetail)
  }
  return definedCrs
}

/**
 * 是否已注册
 */
export function hasRegistered(crsCode: string) {
  return isOlDefaultCrs(crsCode) ? true : definedCrs.has(crsCode)
}

/**
 * 是否是openlayers 默认的空间参考
 * @param crsCode crs code eg: 'EPSG:4326'
 * @returns true/false
 */
export function isOlDefaultCrs(crsCode: string) {
  return EPSG3857 === crsCode || EPSG4326 == crsCode
}
